// extracted by mini-css-extract-plugin
module.exports = {"projects":"Projects_projects__17wGL","items":"Projects_items__2Q_U5","swipe":"Projects_swipe__2Ta8q"};